/* Placement question block buttons logic */
var questionNumber;
var questionNumeral;

$(function() {
    $('.half-gutter button').on('click', function () {
        // Handle active class between children
        $(this).parent().siblings().find('button').removeClass('active');

        if($(this).attr('id') != 'next-btn') {
            // console.log('Not NEXT button');
            $(this).addClass('active');
            if ($(this).text() == 'Yes' || $(this).text() == 'Not Yet') {
                $(this).parent().parent().parent().parent().removeClass('highlight-question');
            }
        }

        // Get question block number
        questionNumber = $('.question-block:visible').attr('id').split("_").pop();
        questionNumeral = parseInt(questionNumber);

        var divider = 3;

        if(questionNumeral == 0)
            divider = 2;

        // If all questions were answered
        if ($('.page-content').children().eq(questionNumber).find('button.active:visible').not('.unsure-block button.active:visible').length == parseInt($('button:visible').length / divider)) {
            $('#next-btn').removeAttr('disabled');
            // console.log('all questions were answered');
        }
    });

    // Submit button
    $('#next-btn').on('click', function () {
        // console.log('NEXT clicked');
        var activeVisibleBtnText = $('button.active:visible').text().toLowerCase();

        if (~activeVisibleBtnText.indexOf('not yet')) {
            // No has been answered
            window.location.href = '/placement-test-completed?level=' + $('.question-block:visible input:hidden').val();
            // console.log('At least one NO answered');
        }
        else if (~activeVisibleBtnText.indexOf('unsure')) {
            // Unsure has been answered
            $("html, body").animate({ scrollTop: 0 }, "slow");
            $('.unsure-block').show();
            $('.half-gutter button.orange-btn-transparent.active:visible').parent().parent().parent().parent().addClass('highlight-question');
            // console.log('Unsure has been answered');
        }
        else {
            // Yes has been answered to all questions
            // console.log('Yes to all questions');
            // Checking if it is the last question block
            if ($('.question-block:visible input:hidden').val() == 'calculus') {
                window.location.href = 'placement-test-completed?level=postsecondary';
            }
            else {
                $("html, body").animate({ scrollTop: 0 }, "slow");
                // var $current = $('.question-block:visible');
                questionNumeral++;
                // $current.hide();
                // $current.next().show();
                $('.unsure-block').hide();
                // $('#next-btn').prop('disabled', true);
                // window.history.pushState("", "", "?block=" + Number(questionNumeral));
                window.location.replace(window.location.href.split('?')[0] + "?block=" + Number(questionNumeral));
                // noty({text: 'You\'ve completed Question Block ' + questionNumber + ', answering Yes to each question. Let\'s keep going.', layout: 'topRight', type: 'success', timeout: 5000});
            }
        }
    });
});

/* Handle url query string */
$(document).ready(function() {
    if (window.location.href.indexOf('?') == -1) { // No query string exists
        window.history.pushState("", "", "?block=" + $('.question-block:visible').attr('id').split("_").pop());
    }
});

/* Handle on back button */
$(window).on('popstate', function(event) {
    var $current = $('.question-block:visible');

    if(questionNumeral > 0) {
        questionNumeral--;
        $current.hide();
        $current.prev().show();
        $('#next-btn').prop('disabled', false);
        $('.unsure-block').hide();
        window.history.pushState("", "", "?block=" + Number(questionNumeral));
    }
});
//# sourceMappingURL=placement.js.map
